<template>
  <div class="course">
    <Head :headerNum="4" />

    <div
      class="banner clear"
      style="margin-top: 64px"
      id="banner"
      v-if="getContent.length !== 0"
      v-show="getContent.shufflings.length !== 0"
    >
      <div class="banner-content">
        <a
          class="image_bananr"
          :href="
            getContent.shufflings.length ? getContent.shufflings[1].jumpUrl : ''
          "
          ><img
            :src="
              getContent.shufflings.length
                ? getContent.shufflings[0].imageUrl
                : ''
            "
            v-if="getContent.length !== 0"
        /></a>
        <a
          class="banner-right"
          v-if="getContent.length !== 0"
          :href="
            getContent.shufflings.length ? getContent.shufflings[1].jumpUrl : ''
          "
          ><img
            :src="
              getContent.shufflings.length
                ? getContent.shufflings[1].imageUrl
                : ''
            "
            alt=""
            v-if="getContent.length !== 0"
        /></a>
      </div>
    </div>
    <!--速抢剩余名额--弹框-->
    <div class="order-window">
      <div class="tiandaka">
        <img src="./img/windows_7tiandaka.png" alt="成功预约打卡成功-弹框" />
      </div>
      <img
        class="close_windows"
        src="./img/close_windows.png"
        onclick="$('.order-window').hide();"
        alt="close按钮"
      />
    </div>

    <div class="div-details">
      <ul class="vertical-nav nav nav-pills fl" id="myTab">
        <li
          id="myTab-li"
          v-for="(item, index2) in getList.trafficList"
          :key="index2"
        >
          <p>{{ item.name }}</p>
          <ul style="width: 90%">
            <li
              @click="getContentId(item1.id, index, index2)"
              class="active get-list-li"
              v-for="(item1, index) in item.trafficList"
              :key="index"
              :class="{ selectli: item1.name === selectName }"
            >
              <span style="cursor: pointer">{{ item1.name }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="tab-content tab-content-list fl">
        <!--写作王牌班-->
        <div class="tab-pane active" id="Writing">
          <ul class="nav nav-pills divstyletab" id="WritingTab">
            <li
              v-for="(item, index) in getContent.trafficList"
              :key="index"
              :class="{ active: activeItem === index }"
              @click="changeItem(index)"
            >
              <a href="javascript:" id="hover-a">{{ item.name }}</a>
            </li>
          </ul>
          <div class="tab-content tab-content-con">
            <transition
              enter-active-class="fadeIn"
              leave-active-class="fadeOut"
              :duration="{ enter: 1000, leave: 0 }"
            >
              <img
                v-for="(item, index) in getContent.trafficList"
                :key="index"
                :src="item.imageUrl"
                class="animated"
                v-if="index === activeItem"
              />
            </transition>
          </div>
        </div>
      </div>
      <div class="xiaozhishou fl hidden-xs" v-if="!isPhone">
        <img :src="getList.spreadUrl" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import ajax from "./../../api/ajax";
import Head from "./../../components/Head";
export default {
  name: "Course",
  data() {
    return {
      isPhone: false, //是否手机
      isFade: false, //图片切换
      url: "https://winielts.com", //默认路径
      getList: [], //获取菜单数据
      getContent: [], //获取内容数据
      activeItem: 0, //图片切换索引
      isActivity: false, //是否活动
      urlId: 0, //URL传递的id参数
      selectName: "" //左侧菜单选中的名字
    };
  },
  components: {
    Head
  },
  methods: {
    async course() {
      //课程
      const getContent = await ajax(this.url + "/api/web/getByFid", { id: 4 });
      this.getContent = getContent.data;
      this.isActivity = false;
      this.activeItem = 0;
      this.selectName = this.getList.trafficList[0].trafficList[0].name;
    },
    async activity() {
      //限时活动
      this.isActivity = true;
      const id = this.getList.trafficList[1].trafficList[0].id;
      this.activeItem = 0;
      const getContent = await ajax(this.url + "/api/web/getByFid", { id: id });
      this.getContent = getContent.data;
      console.log(getContent.data);
      this.selectName = this.getList.trafficList[1].trafficList[0].name;
    },
    documentWidth() {
      //是否是手机
      if (document.body.clientWidth <= 750) {
        this.isPhone = true;
      }
    },
    async getContentId(id, index, index2) {
      //左边菜单
      const getContent = await ajax(this.url + "/api/web/getByFid", { id: id });
      this.getList.trafficList.forEach(item => {
        item.trafficList.forEach(item1 => {
          if (item1.id === id) {
            this.selectName = item1.name;
          }
        });
      });
      this.getContent = getContent.data;
      this.activeItem = 0;
    },
    changeItem(index) {
      //切换图片
      this.isFade = true;
      setTimeout(() => {
        this.isFade = false;
      }, 1000);
      this.activeItem = index;
    },
    isHasId() {
      //URL是否含有id
      let domain = window.location.href;
      if (domain.includes("?")) {
        let cha = "";
        let num = 0;
        let chaNum = domain.indexOf("id=");
        cha = domain.substr(chaNum);
        num = cha.replace(/[^0-9]/gi, "");
        num = ~~num;
        this.urlId = num;
      }
    }
  },
  async mounted() {
    this.isHasId();
    let id = this.urlId !== 0 ? this.urlId : 4;
    console.log(id);
    this.documentWidth();
    const getList = await ajax(this.url + "/api/web/getList");
    const getContent = await ajax(this.url + "/api/web/getByFid", { id: id });
    this.getList = getList.data;
    this.getContent = getContent.data;
    this.selectName = this.getList.trafficList[0].trafficList[0].name;
    if (id !== 4) {
      this.getList.trafficList[0].trafficList.forEach(item => {
        if (item.id === id) {
          this.selectName = item.name;
        }
      });
    }
  }
};
</script>

<style scoped>
a {
  color: #000;
}
.navbar-top-div {
  display: flex;
  align-items: center;
  /*justify-content: space-evenly;*/
}
.logo-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
.course {
  background: #f7f7f7;
}
img {
  width: 100%;
}
.banner {
  width: 100%;
  background: url("img/image_bg.png") no-repeat;
  overflow: hidden;
}
.banner-content {
  width: 63.8%;
  text-align: center;
  display: block;
  margin: 0 auto;
}
.banner-content a:nth-child(1) {
  float: left;
  width: 50%;
}
.banner-content a:nth-child(2) {
  float: left;
  width: 48.5%;
  margin: 0 0 0 1.5%;
}
#hover-a:hover {
  color: #000;
}
/*<!--速抢剩余名额--弹框-->*/
.order-window {
  display: none;
  position: fixed;
  top: 20%;
  left: 20%;
  width: 575px;
  z-index: 100;
}
.order-window {
  position: fixed;
  top: 20%;
  left: 33%;
  width: 575px;
}
.tiandaka {
  width: 100%;
  position: relative;
}
.close_windows {
  width: 48px;
  position: absolute;
  top: -24px;
  right: 12px;
  cursor: pointer;
}
/*内容*/
.div-details {
  width: 88%;
  margin: 0 auto;
  display: block;
  text-align: center;
  background: #f7f7f7;
  padding-top: 10px;
  margin-left: 11.2%;
  display: flex;
}
.vertical-nav.nav {
  height: 100%;
  width: 120px;
  padding-bottom: 20px;
  background: #fff;
  text-align: center;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#myTab-li {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
}
.vertical-nav.nav p {
  width: 55px;
  font-family: "思源黑体";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0px;
  color: #202020;
  border-bottom: 4px solid #ffc929;
  border-radius: 2px;
  display: block;
  margin: 15px auto;
  padding-bottom: 4px;
}
.get-list-li {
  /*width: 110px;*/
  height: 40px;
  font-family: "思源黑体";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 36px;
  letter-spacing: 0px;
  color: #202020;
  display: block;
  margin: 8px auto;
  box-sizing: border-box;
  border: 2px solid transparent;
  width: 100% !important;
}

.get-list-li:hover,
.get-list-li:focus {
  box-sizing: border-box;
  background-color: #fff;
  border-style: solid;
  border-image-source: linear-gradient(
    0deg,
    rgba(255, 191, 0, 0.98) 0%,
    rgba(255, 230, 102, 0.98) 100%
  );
  border-image-slice: 1;
}
.selectli {
  box-sizing: border-box;
  background-image: linear-gradient(
      0deg,
      rgba(255, 191, 0, 0.98) 0%,
      rgba(255, 230, 102, 0.98) 100%
    ),
    linear-gradient(#ffc929, #ffc929);
  background-blend-mode: normal, normal;
  border: 0;
  border-radius: 4px;
  color: #333333;
  line-height: 40px;
}
.vertical-nav.nav-pills > li {
  float: none;
}
.tab-content-list {
  width: 800px;
  background-color: #ffffff;
  margin: 0 10px 20px 10px;
  padding-bottom: 20px;
}
.divstyletab {
  margin: 20px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
}
.divstyletab li {
  width: 120px;
  font-family: "思源黑体";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #333333;
}
.divstyletab.nav-pills > li > a {
  border-radius: 0;
  color: #333333;
}
.divstyletab.nav > li > a:hover,
.divstyletab.nav > li > a:focus {
  color: #333333;
  background-color: #fff;
  border-radius: 0;
}
.divstyletab.nav-pills > li.active,
.divstyletab.nav-pills > li.active:hover,
.divstyletab.nav-pills > li.active:focus {
  font-family: "思源黑体";
  border-bottom: 2px solid #ffc20a;
  color: #333333;
  background-color: #fff;
}

.xiaozhishou {
  width: 390px;
}

@media only screen and (max-width: 1500px) and (min-width: 1201px) {
  .div-details {
    width: 93%;
    margin-left: 7%;
  }
  .xiaozhishou {
    width: 22%;
  }
  .tab-content-list {
    width: 60%;
  }
}
@media only screen and (max-width: 1200px) and (min-width: 1001px) {
  .navbar-top .navbar-top-div {
    margin-left: 15%;
  }
  .div-details {
    width: 95%;
    margin-left: 5%;
  }
  .xiaozhishou {
    width: 22%;
  }
  .tab-content-list {
    width: 60%;
  }
}
@media only screen and (max-width: 1000px) and (min-width: 768px) {
  .navbar-top .navbar-top-div {
    margin-left: 15%;
  }
  .div-details {
    width: 95%;
    margin-left: 5%;
  }
  .xiaozhishou {
    width: 22%;
  }
  .tab-content-list {
    width: 60%;
  }
}
@media only screen and (max-width: 767px) and (min-width: 301px) {
  .banner-content {
    width: 95%;
    text-align: center;
    display: block;
    margin: 0 auto;
  }
  .div-details {
    width: 100%;
    margin-left: 0;
    padding-top: 0;
    background: #fff;
  }
  .xiaozhishou {
    width: 22%;
  }
  .vertical-nav.nav p {
    float: left;
    margin: 8px 0;
  }
  .get-list-li {
    float: left;
    margin: 6px 12px 0 12px;
    height: 36px;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vertical-nav.nav-pills > li.active,
  .vertical-nav.nav-pills > li.active:hover,
  .vertical-nav.nav-pills > li.active:focus {
    height: 36px;
    line-height: 36px;
  }
  .get-list-li > a:hover,
  .get-list-li > a:focus {
    line-height: 30px;
  }
  .vertical-nav.nav {
    float: none;
    width: 94%;
    background: #fff;
    text-align: center;
    padding: 0;
    margin: 0 auto;
    border-bottom: 1px solid #f8f8f8;
    padding-bottom: 10px;
  }
  .divstyletab {
    margin: 0 20px 20px 20px;
  }
  .divstyletab li {
    width: 100px;
  }
  .tab-content-list {
    width: 245%;
    display: block;
    margin: 0 auto;
    float: none;
  }
  .tab-pane img {
    width: 96%;
  }
}
@media only screen and (max-width: 581px) and (min-width: 301px) {
  .divstyletab li {
    width: 85px;
    font-size: 14px;
  }
  .divstyletab li > a {
    padding: 0;
  }
  .vertical-nav.nav p {
    float: left;
    margin: 8px 0;
    font-size: 16px;
  }
  .vertical-nav.nav-pills > li {
    float: left;
    width: 100px;
    margin: 6px 0 0 12px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }

  .get-list-li > a:hover,
  .get-list-li > a:focus {
    line-height: 30px;
  }
  .vertical-nav.nav {
    float: none;
    width: 94%;
    background: #fff;
    text-align: center;
    padding: 0;
    margin: 0 auto;
    border-bottom: 1px solid #f8f8f8;
  }
  .divstyletab {
    margin: 10px 20px;
  }
  .nav-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .nav-label li {
    height: 30px;
    line-height: 36px;
    margin-top: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .nav-label li.time-activities {
    height: 30px;
    margin: 0;
    width: 90px;
  }
  .nav-label li.on {
    /*line-height: 30px;*/
    /*margin: 0 10px;*/
    margin: 0;
  }
}
@media only screen and (max-width: 421px) and (min-width: 301px) {
  .divstyletab li {
    width: 65px;
    font-size: 12px;
  }
  .vertical-nav.nav p {
    width: 40px;
    float: left;
    margin: 8px 4px 0 0;
    font-size: 14px;
    padding-bottom: 0;
  }
  .get-list-li {
    float: left;
    width: 80px;
    margin: 6px 0 0 0;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  /*.get-list-li > a:hover, .get-list-li > a:focus {*/
  /*line-height: 26px;*/
  /*}*/
  .vertical-nav.nav-pills > li.active,
  .vertical-nav.nav-pills > li.active:hover,
  .vertical-nav.nav-pills > li.active:focus {
    height: 30px;
    line-height: 30px;
  }
  .vertical-nav.nav {
    padding-bottom: 6px;
  }
  .divstyletab {
    width: 94%;
    background: #fff;
    text-align: center;
    padding: 0;
    margin: 10px auto;
  }
}
@media only screen and (max-width: 380px) and (min-width: 301px) {
  .vertical-nav.nav-pills > li {
    width: 76px;
  }
  .vertical-nav.nav-pills > li.card-minWidth {
    width: 82px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Course/Course.vue